import type { FavoriteProduct } from "@/api/hooks";

/**
 * Favori satırındaki ürünün ObjectId'si.
 *
 * Satır, ürün detayıyla aynı gövdede geliyor; detay zaten id ile çağrıldığı
 * için gövdede uzun süre `productId` yoktu. Alan backend'e eklendi ama web
 * daha önce deploy olabilir, o yüzden yoksa seçili varyanttan/slicer'dan
 * çıkarılır. Varyantsız bir ürün iki listede de yer almaz — o durumda null
 * döner ve satır linksiz/kalpsiz çizilir, uydurma bir id ile yanlış ürünü
 * favoriden çıkarmaktansa.
 */
export const resolveFavoriteProductId = (
  product: FavoriteProduct,
): string | null => {
  if (product.productId) return product.productId;

  const selectedVariant =
    product.firstVariantGroup?.find((variant) => variant.isSelected) ??
    product.secondVariantGroup?.find((variant) => variant.isSelected);
  if (selectedVariant?.productId) return selectedVariant.productId;

  for (const group of product.slicerGroups ?? []) {
    const selected = group.values?.find((value) => value.isSelected);
    if (selected?.productId) return selected.productId;
  }

  return null;
};
